import { createSelector } from '@ngrx/store';

import * as fromReducer from '@packages/packages-result/store/reducers/ui/showed-details.reducer';
import {
  PackageResultModuleState, UIPackagesResultState
} from '@packages/packages-result/store/state/packages-result-module.state';
import { packagesResultRootSelector } from '@packages/packages-result/store/selectors/packages-result-root.selector';

export const getUIPackagesResultState = createSelector(packagesResultRootSelector, (state: PackageResultModuleState) => state.ui);

export const getShowedPackageState = createSelector(getUIPackagesResultState,
  (state: UIPackagesResultState) => state.showedPackageDetails);

export const showedPackageDetailsSelector = createSelector(getShowedPackageState, fromReducer.selectAll);
